<template>
  <div
    class="
      $typography/size:large
      @768/layout/border:bottom:3pt
      layout/border:bottom:2pt
      layout/flex
      layout/grid:gap:cap
      layout/padding:bottom:cap
      layout/padding:top:cap
      layout/relative
      layout/width:100%
    "
    >
    <div
      class="
        layout/flex:grow
        link/focus
      "
      >
      <input
        ref="input"
        :aria-label="ariaLabelInput"
        :data-gtm="gtm"
        :placeholder="inputPlaceholder"
        :value="value"
        class="
          layout/margin:left:clear
          layout/margin:right:clear
          typography
        "
        enterkeyhint="done"
        name="q"
        type="text"
        @input.prevent="$emit('searchInput', $event.target.value)"
      >
    </div>
    <Icon
      v-if="showIconGlass"
      key="iconGlass"
      icon-name="icon__glass--24--stroke.svg"
      class-name="
        $color/gray:666
        typography/icon
      "
    />
    <div
      v-else
      key="clear"
      :aria-label="ariaLabelReset"
      class="link/focus"
      type="reset"
      @click.prevent="$emit('searchReset', $event.target.value)"
      >
      <Icon
        icon-name="icon__x--24--stroke.svg"
        class-name="typography/icon"
        style="pointer-events: none;"
      />
    </div>
  </div>
</template>

<script>
  import Icon from '../icons/icon.vue';

  export default {
    components: { Icon },
    props: {
      ariaLabelInput: { type: String, required: true },
      ariaLabelReset: { type: String, required: true },
      gtm: { type: String, required: true },
      inputPlaceholder: { type: String, required: true },
      value: { type: String, required: false, default: "" },
    },
    computed: {
      showIconGlass() {
        if (this.value != null && this.value.length > 0 ) {
          return false;
        }
        return true;
      },
    },
    methods: {
      blurInput() {
        this.$refs.input.blur();
      }
    }
  };
</script>

<style scoped>
  input::placeholder {
    color: #666;
  }
</style>
